<div class="syn-error__container">
   <div>
    <pre>
                _____
           _.-''     ``-._
         ,'               `.
        /                   \
       /                     \
      :                       :
      |_______________________|
      ;_______________________:
     / |       ,'   `.       | \
     : `.___.-'  ___  `-.___.' :
     \/`._   _,-'   `-._   _,'\/
     ,\.-'      _.-._      `-./.
   ,'        _,' ___ `._        `.
   | :.    ,'_,-' . `-._`-.   .: |
   | ':.  '-'     |     `-'  .:' |
   :  ':.         |         .:'  ;
    \  ,-         |         -.  /
     \'    \      '      /    `/
      \    ,`   ,'^`.   '.    /
       \  ( O`-','-'.`-'O )  /
        `-.___,'     `.___.-'

    </pre>
  </div>
  <div>
    <h2>404</h2>
    <p>
      <cite>These are not the pages you are looking for</cite> - Obiwan K.
    </p>
  </div>
</div>
